import React, { useState, useEffect } from "react";
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import Ping from '../../../modules/custom/accounts/troubleshoot/components/Ping';
import Traceroute from '../../../modules/custom/accounts/troubleshoot/components/Traceroute';
import BGP from '../../../modules/custom/accounts/troubleshoot/components/table_BGP';
import MPLS from '../../../modules/custom/accounts/troubleshoot/components/MPLS';
import LDP from '../../../modules/custom/accounts/troubleshoot/components/LDP';
import { useAuth } from '../../../modules/auth';
import { useAppSelector } from '../../../../redux/hooks';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para mostrar mientras carga

const TroubleshootingPage: React.FC = () => {
  const Plansus = useAppSelector(state => state.planSlice.plans);
  const { currentUser } = useAuth();
  const tenantName = useAppSelector(state => state.NametenantSlice.name); // Nombre del tenant activo
  const [flag, setFlag] = useState<number>();
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const [number, setNumber] = useState<number>();
  const [loading, setLoading] = useState(true); // Estado de loading
  const navigate = useNavigate();

  // Lógica para redirigir si no tiene permisos de troubleshooting
  useEffect(() => {
    console.log('ListaPermisosTenant', ListaPermisosTenant)
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Detener el estado de loading cuando los permisos están cargados

        if (!ListaPermisosTenant.includes('Ctx.Troubleshooting.Ping')) {
          if (!ListaPermisosTenant.includes('Home.Status')) {
            // Si no tiene permisos para troubleshooting ni Home.Status, redirige a cloudConnectivity
            navigate('/cloudConnectivity');
          } else {
            // Si no tiene permisos para troubleshooting pero sí Home.Status, redirige a dashboard/status
            navigate('/dashboard/status');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo para simular la validación de permisos

    // Limpiar el timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping')) {
      setFlag(1);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Traceroute')) {
      setFlag(2);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP')) {
      setFlag(3);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS')) {
      setFlag(4);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP')) {
      setFlag(5);
    } else if (ListaPermisosTenant.includes('Ctx.Troubleshooting.LDP')) {
      setFlag(5);
    }
  }, [currentUser, ListaPermisosTenant]);

  // Mostrar spinner mientras se validan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <div className='card mb-5 mb-xl-5'>
      <ul style={{ marginLeft: '25px', marginRight: '25px' }} className="nav nav-tabs nav-line-tabs mb-5 fs-6">
        {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.Ping')) && (
          <li className="nav-item">
            <NavLink className="nav-link f-parrafo fs-p" to="ping" onClick={() => setFlag(1)}>
              Ping
            </NavLink>
          </li>
        )}
        {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Traceroute') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.Traceroute')) && (
          <li className="nav-item">
            <NavLink className="nav-link f-parrafo fs-p" to="traceroute" onClick={() => setFlag(2)}>
              Traceroute
            </NavLink>
          </li>
        )}
        {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.BGP')) && (
          <li className="nav-item">
            <NavLink className="nav-link f-parrafo fs-p" to="bgp" onClick={() => setFlag(3)}>
              BGP
            </NavLink>
          </li>
        )}
        {tenantName !== 'AT&T' && ( // Ocultar MPLS y LDP si el tenant es AT&T
          <>
            {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS') && !ListaPermisosTenant.includes('CTXR.Troubleshooting.MPLS')) && (
              <li className="nav-item">
                <NavLink className="nav-link f-parrafo fs-p" to="mpls" onClick={() => { setFlag(4); setNumber(4); }}>
                  MPLS
                </NavLink>
              </li>
            )}
            {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP') && !ListaPermisosTenant.includes('CTXR.Troubleshooting.LDP')) && (
              <li className="nav-item">
                <NavLink className="nav-link f-parrafo fs-p" to="ldp" onClick={() => { setFlag(5); setNumber(5); }}>
                  LDP
                </NavLink>
              </li>
            )}
          </>
        )}
      </ul>

      <div style={{ marginLeft: '25px', marginRight: '25px' }} className="tab-content" id="myTabContent">
        <Routes>
          {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Ping') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.Ping')) && (
            <Route path="ping" element={<Ping tab={flag} />} />
          )}
          {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.Traceroute') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.Traceroute')) && (
            <Route path="traceroute" element={<Traceroute tab={flag} />} />
          )}
          {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.BGP')) && (
            <Route path="bgp" element={<BGP tab={flag} />} />
          )}
          {tenantName !== 'AT&T' && (
            <>
              {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.MPLS')) && (
                <Route path="mpls" element={<MPLS tab={flag} id={number} />} />
              )}
              {(currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.LDP') || !ListaPermisosTenant.includes('Ctx.Troubleshooting.LDP')) && (
                <Route path="ldp" element={<LDP tab={flag} id={number} />} />
              )}
            </>
          )}
          <Route path="*" element={<Navigate to="ping" />} />
        </Routes>
      </div>
    </div>
  );
};

export { TroubleshootingPage };
